import { trigger, transition, style, animate, query, group } from '@angular/animations';

const FADE_DURATION = '300ms ease';

/** Cross-fade completo para el router-outlet raíz (app.html) */
export const routeFadeAnimation = trigger('routeAnimation', [
  transition('* <=> *', [
    group([
      query(':leave', [
        style({ opacity: 1 }),
        animate(FADE_DURATION, style({ opacity: 0 }))
      ], { optional: true }),
      query(':enter', [
        style({ opacity: 0 }),
        animate(FADE_DURATION, style({ opacity: 1 }))
      ], { optional: true })
    ])
  ])
]);

/** Solo fade-in para el router-outlet del shell (evita doble animación) */
export const shellFadeAnimation = trigger('routeAnimation', [
  transition('* <=> *', [
    query(':leave', [
      style({ display: 'none' })
    ], { optional: true }),
    query(':enter', [
      style({ opacity: 0 }),
      animate(FADE_DURATION, style({ opacity: 1 }))
    ], { optional: true })
  ])
]);
